/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 Forum = {
    vote: {
        topic: function(e) {
            var button = $(this);

            if (button.hasClass('disabled')) {
                return false;
            }

            var id   = button.data('id');
            var type = button.data('type');

            if (id > 0) {
                button.addClass('disabled');

                $.ajax({
                    url: '/a/viewTopic/votes/send/topic',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        'id': id,
                        'type': type
                    },
                }).done(function(data) {
                    button.removeClass('disabled');

                    if (data.status == "error") {
                        var message = "";

                        for (i = data.messages.length - 1; i >= 0; i--) {
                            message += data.messages[i];

                            if (i > 0) {
                                message += '<br>';
                            }
                        }

                        Alertbox({
                            title: "Erro ao votar",
                            content: message,
                            type: 'error'
                        });
                    } else if (data.status == "success") {
                        var pos = $(".forum-topic-vote[data-type='positive']");
                        var neg = $(".forum-topic-vote[data-type='negative']");

                        if (type == 'positive') {
                            pos.toggleClass('active');

                            if (neg.hasClass('active')) {
                                neg.removeClass('active');
                            }
                        } else if (type == 'negative') {
                            neg.toggleClass('active');

                            if (pos.hasClass('active')) {
                                pos.removeClass('active');
                            }
                        }

                        pos.find('.number').text(data.votes.positive);
                        neg.find('.number').text(data.votes.negative);
                    }
                });
            }
        },
        post: function(e) {
            var button = $(this);

            if (button.hasClass('disabled')) {
                return false;
            }

            var id   = button.data('id');
            var type = button.data('type');

            if (id > 0) {
                button.addClass('disabled');

                $.ajax({
                    url: '/a/viewTopic/votes/send/post',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        'id': id,
                        'type': type
                    },
                }).done(function(data) {
                    button.removeClass('disabled');

                    if (data.status == "error") {
                        var message = "";

                        for (i = data.messages.length - 1; i >= 0; i--) {
                            message += data.messages[i];

                            if (i > 0) {
                                message += '<br>';
                            }
                        }

                        Alertbox({
                            title: "Erro ao votar",
                            content: message,
                            type: 'error'
                        });
                    } else if (data.status == "success") {
                        var pos = button.parent().parent().find(".forum-topic-post-vote[data-type='positive']");
                        var neg = button.parent().parent().find(".forum-topic-post-vote[data-type='negative']");

                        if (type == 'positive') {
                            pos.toggleClass('active');

                            if (neg.hasClass('active')) {
                                neg.removeClass('active');
                            }
                        } else if (type == 'negative') {
                            neg.toggleClass('active');

                            if (pos.hasClass('active')) {
                                pos.removeClass('active');
                            }
                        }

                        pos.find('.number').text(data.votes.positive);
                        neg.find('.number').text(data.votes.negative);
                    }
                });
            }
        },
    },
    report: {
        show: function() {
            var id = $(this).data('id');

            var html = '';

            html += '<form class="form-forum-topic-report" data-id="'+id+'">';
            html += '<div class="form-group">';
            html += '<label>Motivo</label>';
            html += '<textarea class="form-control" name="motive" placeholder="Qual o motivo da denúncia?"></textarea>';
            html += '</div>';
            html += '<center><button type="submit" class="btn btn-primary btn-warning">Enviar</button></center>';
            html += '</form>';

            Alertbox({
                title: "Reportar tópico",
                content: html,
                type: 'misc'
            });
        },
        send: function(e) {
            e.preventDefault();

            var form = $(this);

            if (form.hasClass('disabled')) {
                return false;
            }

            var id = form.data('id');
            var motive = form.find('textarea[name="motive"]').val();

            if (motive == '') {
                form.effect('shake', { distance: 3 });
            } else {
                form.addClass('disabled').animate({'opacity': 0.5});

                $.ajax({
                    url: '/a/viewTopic/report/send',
                    type: 'POST',
                    dataType: 'json',
                    data: {'id': id, 'motive': motive},
                }).done(function(data) {
                    form.removeClass('disabled').animate({'opacity': 1});

                    if (data.status == 'error') {
                        var message = "";

                        for (i = data.messages.length - 1; i >= 0; i--) {
                            message += data.messages[i];

                            if (i > 0) {
                                message += '<br>';
                            }
                        }

                        Alertbox({
                            title: "Erro ao reportar tópico",
                            content: message,
                            type: 'error'
                        });
                    } else {
                        $(".forum-topic-report[data-id='"+id+"']").parent().remove();
                        $.fancybox.close();

                        Alertbox({
                            title: 'Enviado com sucesso!',
                            content: "Sua denúncia foi enviada com sucesso. Nossa equipe irá averiguar o caso, agradecemos pela sua contribuição em manter a organização do nosso site.",
                            type: 'success'
                        });
                    }
                });
            }
        }
    },
    loadBadges: function(e) {
        var userId = $(this).data('user-id');

        var box = $(this).closest('.badges');

        $.ajax({
            url: '/a/viewTopic/badges/load',
            type: 'POST',
            dataType: 'json',
            data: {'userId': userId},
        }).done(function(data) {
            box.find('.row:nth-child(2)').remove();
            box.find('.row').html(data.html);

            Main.plugins.tooltip();
        });
    },
    quote: function() {
        var box = $(this).closest('.forum-topic-entry');

        var text = $.trim(box.find('.ctn-bbcode').text());
        var author = $.trim(box.find('.username .text').text());

        var value = "[quote][b]"+author+"[/b] escreveu:\n"+text+"[/quote]";

        var prev = $.trim($("#content-input").val());
        $("#content-input").val(prev + value);

        $("html, body").animate({
            scrollTop: $('#forum-form-comment').offset().top
        }, 'slow');
    },
    edit: {
        show: function() {
            var button = $(this);

            var entry = button.closest('.forum-topic-entry');

            if (button.hasClass('editing')) {
                var textHtml = entry.find('.ctn-html').html();
                entry.find('.text-area').html(textHtml);

                button.removeClass('editing');
            } else {
                button.addClass('editing');

                var id   = button.data('id');
                var type = button.data('type');

                var content = $.trim(entry.find('.ctn-bbcode').html());

                var html = '<form class="edit-content-forum" data-id="'+id+'" data-type="'+type+'">';
                html += '<div class="create-content-area xlarge mb-3">';
                html += '<div class="row no-gutters create-content-text">';
                html += '<div class="col-md-11 col-10">';
                html += '<textarea class="create-content-input input-enable-mention-user" id="edit-content-input" placeholder="Digite o conteúdo" required>';
                html += content;
                html += '</textarea>';
                html += '</div>';

                html += '<div class="col-md-1 col-2">';
                html += '<button type="submit" class="create-content-submit">';
                html += '<i class="fas fa-paper-plane"></i>';
                html += '</button>';
                html += '</div>';
                html += '</div>';

                html += '<div class="row no-gutters mt-3 create-content-bbcode">';
                html += '<div class="col-12">';
                html += '<button type="button" class="bbcode-button bbcode-insert" data-receiver="edit-content-input" data-bbcode="b"><i class="fas fa-bold"></i></button>';
                html += '<button type="button" class="bbcode-button bbcode-insert" data-receiver="edit-content-input" data-bbcode="i"><i class="fas fa-italic"></i></button>';
                html += '<button type="button" class="bbcode-button bbcode-insert" data-receiver="edit-content-input" data-bbcode="u"><i class="fas fa-underline"></i></button>';

                html += '<button type="button" class="bbcode-button bbcode-insert" data-receiver="edit-content-input" data-bbcode="img"><i class="far fa-image"></i></button>';
                html += '<button type="button" class="bbcode-button bbcode-insert" data-receiver="edit-content-input" data-bbcode="youtube"><i class="fab fa-youtube"></i></button>';
                html += '<button type="button" class="bbcode-button bbcode-insert" data-receiver="edit-content-input" data-bbcode="url=http://prohabbo.com.br" data-bbcode-close="url"><i class="fas fa-link"></i></button>';

                html += '<button type="button" class="bbcode-button bbcode-insert" data-receiver="edit-content-input" data-bbcode="left"><i class="fas fa-align-left"></i></button>';
                html += '<button type="button" class="bbcode-button bbcode-insert" data-receiver="edit-content-input" data-bbcode="center"><i class="fas fa-align-center"></i></button>';
                html += '<button type="button" class="bbcode-button bbcode-insert" data-receiver="edit-content-input" data-bbcode="right"><i class="fas fa-align-right"></i></button>';

                html += '<button type="button" class="bbcode-button emojis-open" data-receiver="#edit-content-input"><i class="far fa-smile"></i></button>';
                html += '</div>';
                html += '</div>';
                html += '</div>';
                html += '</form>';

                entry.find('.text-area').html(html);
            }
        },
        send: function(e) {
            e.preventDefault();

            var form = $(this);

            if (form.hasClass('disabled')) {
                return false;
            }

            var content = form.find('#edit-content-input').val();

            if (content === '') {
                form.effect('shake', { distance: 3 });
            } else {
                var id = form.data('id');
                var type = form.data('type');

                form.addClass('disabled').animate({'opacity': 0.5});

                $.ajax({
                    url: '/a/viewTopic/edit/send',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        'id': id,
                        'type': type,
                        'content': content
                    }
                }).done(function(data) {
                    form.removeClass('disabled').animate({'opacity': 1});

                    if (data.status == "error") {
                        var message = "";

                        for (i = data.messages.length - 1; i >= 0; i--) {
                            message += data.messages[i];

                            if (i > 0) {
                                message += '<br>';
                            }
                        }

                        Alertbox({
                            title: "Erro ao editar conteúdo",
                            content: message,
                            type: 'error'
                        });
                    } else if (data.status == "success") {
                        $("#forum-topic-entry-"+type+"-"+id).find('.text-area').html(data.html.htmlContent);
                        $("#forum-topic-entry-"+type+"-"+id).find('.ctn-html').html(data.html.htmlContent);
                        $("#forum-topic-entry-"+type+"-"+id).find('.ctn-bbcode').html(data.html.bbcodeContent);

                        $("#forum-topic-entry-"+type+"-"+id).find('.edit-content-button').removeClass('editing');
                    }
                });
            }
        }
    },
    comment: function(e) {
        e.preventDefault();

        var form = $(this);

        if (form.hasClass('disabled')) {
            return false;
        }

        var input  = form.find("#content-input");
        var comment = input.val();

        if (comment === '') {
            form.find('.write').effect('shake', { distance: 3 });
        } else {
            form.addClass('disabled').animate({'opacity': 0.5});

            var idTopic = form.data('id');

            $.ajax({
                url: '/a/viewTopic/posts/send',
                type: 'POST',
                dataType: 'json',
                data: {
                    'id': idTopic,
                    'content': comment
                }
            }).done(function(data) {
                form.removeClass('disabled').animate({'opacity': 1});

                if (data.status == "error") {
                    var message = "";

                    for (i = data.messages.length - 1; i >= 0; i--) {
                        message += data.messages[i];

                        if (i > 0) {
                            message += '<br>';
                        }
                    }

                    Alertbox({
                        title: "Erro ao responder tópico",
                        content: message,
                        type: 'error'
                    });
                } else if (data.status == "success") {
                    input.val('');

                    $("#forum-topic-posts").append(data.html);
                    Main.plugins.tooltip();

                    var el = $("#forum-topic-posts > div:last-child");

                    $("html, body").animate({
                        scrollTop: el.offset().top
                    },'slow');
                }
            });

        }
    },
    init: function() {
        $(".forum-topic-vote").on('click', Forum.vote.topic);
        $(".forum-topic-post-vote").on('click', Forum.vote.post);

        $(".forum-topic-report").on('click', Forum.report.show);
        $(document).on('submit', '.form-forum-topic-report', Forum.report.send);

        $(document).on('click', '.forum-topic-entry .load-badges', Forum.loadBadges);
        $(document).on('click', '.forum-topic-entry .quote-button', Forum.quote);

        $(document).on('click', '.forum-topic-entry .edit-content-button', Forum.edit.show);
        $(document).on('submit', '.forum-topic-entry .edit-content-forum', Forum.edit.send);

        $("#forum-form-comment").on('submit', Forum.comment);
    }
};
